import { render, staticRenderFns } from "./BonusItemsTable.vue?vue&type=template&id=1824f90e&scoped=true"
import script from "./BonusItemsTable.vue?vue&type=script&lang=js"
export * from "./BonusItemsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1824f90e",
  null
  
)

export default component.exports